var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00beb8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "XMLID_270_",
    x: 8,
    y: 16,
    width: 59.376,
    height: 50.51,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(-0.271 -0.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 76,
    height: 76,
    rx: 20,
    transform: "translate(0.271 0.03)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.27, 0.03)",
    filter: "url(#XMLID_270_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_270_2",
    "data-name": "XMLID_270_",
    d: "M35.946,16.247A13.3,13.3,0,0,0,9.94,13.533,11.815,11.815,0,0,0,13.822,36.51h19.21a10.34,10.34,0,0,0,2.914-20.262Zm-5.982,4.574a1.48,1.48,0,0,1-1.365.912H25.643v5.911a2.955,2.955,0,0,1-5.911,0V21.733H16.777a1.477,1.477,0,0,1-1.045-2.522L21.643,13.3a1.477,1.477,0,0,1,2.089,0l5.911,5.911A1.478,1.478,0,0,1,29.964,20.821Z",
    transform: "translate(15 18)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.4e9c7d08d33a30f44a5543be264695bf.svg";
export { ForwardRef as ReactComponent };